import { graphql } from "gql";

const MESSAGE_FRAGMENT = graphql(`
  fragment Message on Message {
    id
    messageThreadId
    createTime
    updateTime
    createdUserId
    deleted
    editTime
    type
    subType
    text
    actionText
    localizedText
    htmlCloudFrontUrl
    quillDelta
    htmlPdfFile {
      ...File
    }
    isSeen
    sentTime
    locale
    seenUserIdList
    relatedMessageThreadList {
      ...RelatedMessageThread
    }
    fileList {
      ...File
    }
    gifList {
      ...Gif
    }
    reactionList {
      ...Reaction
    }
    quotedMessageList {
      ...QuotedMessage
    }
  }
`);

export default MESSAGE_FRAGMENT;
